/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Adaptive streaming formats supported by the Player.
 */
export enum StreamFormat {
  /**
   * MPEG-DASH (Dynamic Adaptive Streaming over HTTP).
   */
  DASH = "dash",

  /**
   * HLS (HTTP Live Streaming).
   */
  HLS = "hls"
}
